var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8772 4.50391C26.1854 4.50391 19.1272 11.5622 19.1272 20.2539C19.1272 28.9479 26.1854 36.0039 34.8772 36.0039C43.5689 36.0039 50.6272 28.9479 50.6272 20.2539C50.6272 11.5622 43.5689 4.50391 34.8772 4.50391ZM34.8772 9.00391C41.0872 9.00391 46.1272 14.0462 46.1272 20.2539C46.1272 26.4639 41.0872 31.5039 34.8772 31.5039C28.6672 31.5039 23.6272 26.4639 23.6272 20.2539C23.6272 14.0462 28.6672 9.00391 34.8772 9.00391Z",
    fill: "#19295C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8772 63.0039H35.9999C37.2419 63.0039 38.2499 64.0119 38.2499 65.2539C38.2499 66.4959 37.2419 67.5039 35.9999 67.5039H5.6272C4.3852 67.5039 3.3772 66.4959 3.3772 65.2539C3.3772 65.2539 3.3772 63.3999 3.3772 60.7539C3.3772 49.5714 12.4424 40.5039 23.6272 40.5039H35.9999C37.2419 40.5039 38.2499 41.5119 38.2499 42.7539C38.2499 43.9959 37.2419 45.0039 35.9999 45.0039H23.6272C14.9287 45.0039 7.8772 52.0554 7.8772 60.7539V63.0039Z",
    fill: "#19295C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0046 40.5039C45.9338 40.5039 39.3818 47.0559 39.3818 55.1267C39.3818 63.1974 45.9338 69.7494 54.0046 69.7494C62.0753 69.7494 68.6273 63.1974 68.6273 55.1267C68.6273 47.0559 62.0753 40.5039 54.0046 40.5039ZM54.0046 45.0039C59.5913 45.0039 64.1273 49.5399 64.1273 55.1267C64.1273 60.7134 59.5913 65.2494 54.0046 65.2494C48.4178 65.2494 43.8818 60.7134 43.8818 55.1267C43.8818 49.5399 48.4178 45.0039 54.0046 45.0039Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1482 44.7773L43.6545 62.271C42.777 63.1485 42.777 64.575 43.6545 65.4525C44.532 66.3323 45.9585 66.3323 46.836 65.4525L64.3297 47.9588C65.2095 47.0813 65.2095 45.6548 64.3297 44.7773C63.4522 43.8998 62.0257 43.8998 61.1482 44.7773Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/blockIcon.bde2721144ecd4ef3ad9235761b6867b.svg";
export { ForwardRef as ReactComponent };